module.exports = __webpack_public_path__ + "static/img/5.7fdf59e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/sp/5.png
// module id = booU
// module chunks = 0